module.exports = __webpack_public_path__ + "static/media/feed_the_ward.b568fa2b.svg";